import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "The3DCursor"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.75 3H3V9.7575H4.5V4.5H9.75V3ZM22.1175 9.83999L15.3675 6.08999C15.1354 5.95601 14.8495 5.95601 14.6175 6.08999L7.86745 9.83999C7.63501 9.97773 7.49463 10.2298 7.49995 10.5V18C7.50193 18.2721 7.65119 18.5219 7.88995 18.6525L14.64 22.4025C14.7498 22.4648 14.8737 22.4983 15 22.5C15.1286 22.498 15.2548 22.4645 15.3675 22.4025L22.1175 18.6525C22.3533 18.5199 22.4995 18.2706 22.5 18V10.5C22.5022 10.2267 22.3557 9.97388 22.1175 9.83999ZM14.25 20.475L9 17.5575V11.7675L14.25 14.685V20.475ZM15.0001 13.3875L9.79511 10.5L15.0001 7.60503L20.2051 10.5L15.0001 13.3875ZM21 17.5575L15.75 20.475V14.685L21 11.7675V17.5575Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/The3DCursor.vue"]]);
